import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO } from './state';
export default {
	//	...common,
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	//들어오자마자 state 초기화 하는 방법
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.partList = [];
	},
	[types.PART_LIST]: (state, payload) => {
		state.partList = payload;
		if (state.partList != null) {
			state.partList.forEach(row => {
				if (row.scrName == null) row.scrName = '[부품 선택]';

				Object.keys(row).forEach(item => {});
			});
		}
	}
};
